/**
 *
 * DetailWithStatusBar
 *
 */
import React from 'react'

// import styled from 'styled-components';
import Progress from './ProgressBar'

class StatusBox extends React.Component {
  componentWillReceiveProps(nextProps) {
    const { selected } = nextProps // eslint-disable-next-line react/destructuring-assignment
    if (selected !== this.props.selected) {
      // eslint-disable-next-line react/no-unused-state
      this.setState({ selected })
    }
  }

  static defaultProps = {
    obtained: 0,
    outoff: 1,
    colorStart: '#9D2151',
    colorMid: '#F38323',
    colorSuccess: '#2AA955',
    title: 'Results and Records...',
    selected: false,
    onClick: () => {},
  }

  static throwError() {
    // eslint-disable-next-line prefer-rest-params
    // biome-ignore lint/complexity/noArguments: TODO
    return new Error(...arguments)
  }

  render() {
    const {
      title,
      obtained,
      outOff,
      colorStart,
      colorMid,
      colorSuccess,
      className,
      children,
      selected,
      barColor,
      isSingleDate,
      ...rest
    } = this.props
    const completedVal = (parseInt(obtained, 10) / (parseInt(outOff, 10) > 0 ? parseInt(outOff, 10) : 1)) * 100
    let statusbarcolor = colorStart
    if (completedVal >= 33.33 && completedVal <= 66.33) {
      statusbarcolor = colorMid
    } else if (completedVal > 66.33 && completedVal <= 100) {
      statusbarcolor = colorSuccess
    }
    const fontStyleOne = {
      color: '#7D7D84',
      fontSize: '0.875rem',
      marginBottom: '6px',
    }
    const fontStyleTwo = {
      color: '#6C6C6C',
      fontWeight: 300,
      fontSize: '2rem',
      lineHeight: '1',
      marginBottom: '6px',
    }
    const Active = {
      background: '#F3F3F3',
      borderRadius: '3px',
    }
    return (
      <div style={selected ? Active : null} className={className || 'Detail-container'} {...rest}>
        <div style={fontStyleOne}>{title}</div>
        <div style={fontStyleTwo}>{obtained}</div>
        {isSingleDate === true ? (
          <div style={fontStyleOne}>of {outOff} for the day</div>
        ) : (
          <div style={fontStyleOne}>of {outOff} for the week</div>
        )}
        <Progress completed={completedVal} color={barColor || statusbarcolor} />
      </div>
    )
  }
}

export default StatusBox
